import * as Header from '../constants/header.constant'
import { fromPromise } from 'rxjs/observable/fromPromise'
import { switchMap, map } from 'rxjs/operators'
import { ofType } from 'redux-observable'

const headerLogin = action$ =>
  action$.pipe(
    ofType(Header.HEADER_LOGIN),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(Promise.resolve(payload)).pipe(
        map(result => ({
          type: Header.HEADER_LOGIN_SUCCESS,
          payload: { result },
        }))
      )
    )
  )

const headerReport = action$ =>
  action$.pipe(
    ofType(Header.HEADER_REPORT),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(Promise.resolve(payload)).pipe(
        map(result => ({
          type: Header.HEADER_REPORT_SUCCESS,
          payload: { result },
        }))
      )
    )
  )

export default [headerLogin, headerReport]



// WEBPACK FOOTER //
// ./src/epics/header.epic.ts